import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the CycleCountColumnsPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'cycleCountColumns',
})
export class CycleCountColumnsPipe implements PipeTransform {
  /**
   * Takes columns and returns range with indexes.
   */
  transform(columns: Array<string>, length: number): Array<string> {
    if (columns && Array.isArray(columns) && columns.length) {
      let filtered: Array<string> = [];
      if (length && length > 0) {
        for (let i = length; i < columns.length; i++) {
          filtered.push(columns[i]);
        }
      }
      return filtered;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/cycle-count-columns/cycle-count-columns.ts